import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import './QRScanner.css';

function QRScanner({ onScan, onClose }) {
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState('');
  const html5QrCodeRef = useRef(null);

  useEffect(() => {
    startScanner();

    return () => {
      stopScanner();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startScanner = async () => {
    try {
      html5QrCodeRef.current = new Html5Qrcode('qr-reader');
      
      await html5QrCodeRef.current.start(
        { facingMode: 'environment' }, // Use back camera
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        (decodedText) => {
          handleScanSuccess(decodedText);
        },
        (errorMessage) => {
          // Ignore scan errors (they happen constantly while scanning)
        }
      );

      setScanning(true);
    } catch (err) {
      console.error('Error starting scanner:', err);
      setError('Kamera konnte nicht gestartet werden. Bitte überprüfe die Berechtigungen.');
    }
  };

  const stopScanner = async () => {
    if (html5QrCodeRef.current && scanning) {
      try {
        await html5QrCodeRef.current.stop();
        html5QrCodeRef.current.clear();
      } catch (err) {
        console.error('Error stopping scanner:', err);
      }
    }
  };

  const handleScanSuccess = async (decodedText) => {
    try {
      // Stop scanner first
      await stopScanner();

      // Extract session ID from URL or use directly if it's just the code
      let sessionId = decodedText;
      
      // If it's a URL, extract the session ID
      if (decodedText.includes('/session/')) {
        const parts = decodedText.split('/session/');
        sessionId = parts[1].split('?')[0].split('#')[0];
      }

      // Validate format (XXXX-XXXX)
      const sessionIdRegex = /^[A-Z0-9]{4}-[A-Z0-9]{4}$/;
      if (sessionIdRegex.test(sessionId)) {
        onScan(sessionId);
      } else {
        setError('Ungültiger QR-Code');
      }
    } catch (err) {
      console.error('Error processing scan:', err);
      setError('Fehler beim Verarbeiten des QR-Codes');
    }
  };

  const handleClose = async () => {
    await stopScanner();
    onClose();
  };

  return (
    <div className="qr-scanner-modal">
      <div className="qr-scanner-content">
        <div className="scanner-header">
          <h2>QR-Code scannen</h2>
          <button className="btn-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        {error ? (
          <div className="scanner-error">
            <div className="error-icon">⚠️</div>
            <p>{error}</p>
            <button className="btn btn-primary" onClick={handleClose}>
              Schließen
            </button>
          </div>
        ) : (
          <>
            <div id="qr-reader" className="qr-reader"></div>
            <p className="scanner-hint">
              Richte die Kamera auf den QR-Code
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default QRScanner;
